export const products = [
    {
        id: 0,
        img: "/img/Kibsons.png",
        link: "https://spontaneous-raindrop-722604.netlify.app/",
        originalLink: "https://www.kibsons.com/",
        gitHub: "",
    },
    {
        id: 1,
        img: "/img/metro.png",
        link: "https://chipper-longma-89ba89.netlify.app/",
        originalLink: "https://www.metro-markets.com/",
        gitHub: "https://github.com/Ahmd-Khaled/metromarket",
    },
    {
        id: 2,
        img: "/img/filmpire.png",
        link: "https://filmpireahmedkhaled.netlify.app/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/filmpire_ahkhaled",
    },
    {
        id: 3,
        img: "/img/youtubeclone.png",
        link: "https://bespoke-tartufo-d3d4f3.netlify.app/",
        originalLink: "https://www.youtube.com/",
        gitHub: "/",
    },
    {
        id: 4,
        img: "/img/quiety.png",
        link: "https://joyful-cuchufli-450422.netlify.app/",
        originalLink: "/",
        gitHub: "/",
    },
    // {
    //     id: 5,
    //     img: "/img/metro.png",
    //     link: "",
    // },
    {
        id: 6,
        img: "/img/hassan.png",
        link: "https://ahmd-khaled.github.io/HA-CG/",
        originalLink: "http://ha-cg.com/",
        gitHub: "https://github.com/Ahmd-Khaled/HA-CG",
    },
    {
        id: 7,
        img: "/img/letsia.png",
        link: "https://ahmd-khaled.github.io/Letsia/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/Letsia",
    },
    {
        id: 8,
        img: "/img/travel.png",
        link: "https://ahmd-khaled.github.io/travel2/",
        originalLink: "https://www.figma.com/community/file/1045347165786104508",
        gitHub: "https://github.com/Ahmd-Khaled/Travel",
    },
    {
        id: 9,
        img: "/img/efp.png",
        link: "https://ahmd-khaled.github.io/efp/",
        originalLink: "https://www.efp.org/",
        gitHub: "https://github.com/Ahmd-Khaled/efp",
    },
    {
        id: 10,
        img: "/img/scout.png",
        link: "https://ahmd-khaled.github.io/scout/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/scout",
    },
    {
        id: 11,
        img: "/img/splendorous.png",
        link: "https://ahmd-khaled.github.io/splendorous/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/splendorous",
    },
    {
        id: 12,
        img: "/img/volunteer.png",
        link: "https://ahmd-khaled.github.io/volunteer/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/volunteer",
    },
    {
        id: 13,
        img: "/img/co-append.png",
        link: "https://ahmd-khaled.github.io/co-append/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/co-append",
    },
    {
        id: 14,
        img: "/img/bondi.png",
        link: "https://ahmd-khaled.github.io/Bondi/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/Bondi",
    },
    {
        id: 15,
        img: "/img/aldewan.png",
        link: "https://ahmd-khaled.github.io/aldewan2/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/aldewan2",
    },
    {
        id: 16,
        img: "/img/eduport.png",
        link: "https://ahmd-khaled.github.io/eduport/",
        originalLink: "/",
        gitHub: "https://github.com/Ahmd-Khaled/eduport",
    },
];